import { Input } from "@digital-services/ui";

interface Props {
  id: string;
  label: string;
  initialNameValue: string | undefined;
}

// Note that this component created for simple, readonly usage (no context)
export const ReadonlyDisplayName = (props: Props) => {
  const { id, label, initialNameValue } = props;

  return (
    <Input
      type="text"
      id={id}
      data-testid={id}
      label={label}
      value={initialNameValue}
      disabled={true}
      autoComplete="off" // string value should be standard HTML value
    />
  );
};
